import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, onMounted } from "vue";
import { useStore } from 'vuex'
import { Register } from '../http/index'
import { ElMessage } from 'element-plus'
//import { oriVaildImages, guid, FormatToken } from '../global/index'
import { oriVaildImages, guid } from '../global/index'
import Tool from '../global/globaltool' 
import {UserInfo} from '../../class/Userinfo'

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterCom',
  setup(__props) {

const vaildImages = ref(oriVaildImages.value);
let ValidateKey = "";
//组件加载事件
onMounted(() => {
    const t = guid();
    ValidateKey = t;
    vaildImages.value = oriVaildImages.value + t;
});
//点击切换验证码事件
const ChangeImage = () => {
    const t = guid();
    ValidateKey = t;
    vaildImages.value = oriVaildImages.value + t;
}
//vuex
const store = useStore()
const IsShowRegister = computed(() => store.state.IsShowRegister)
const handleClose = (done: () => void) => {
    store.commit('CloseRegister')
    done();
};
const form = ref()
form.value = {
    NickName: "",
    UserName: "",
    Password: "",
}
const Submit = async () => {
    console.log(form.value)
    var data = {
        UserName: form.value.UserName,
        NickName: form.value.NickName,
        Password: form.value.Password,
        ValidateKey: ValidateKey,
        ValidateCode: form.value.ValidateCode,
    }
    //var res = (await Register(data)).data;
    const res = (await Register(data)).data as any ;
    if (res.isSuccess) {
        ElMessage({
            message: '注册成功！',
            type: 'success',
        })
        //let user = JSON.parse(FormatToken(res.result))

        let tokenlet=res?.result;
        console.log("tokenlet:"+tokenlet)
        const user: UserInfo = JSON.parse(new Tool().FormatToken(tokenlet))

        localStorage["token"] = res.result;
        //设置全局变量的值
        store.commit('SettingNickName', user.NickName)
        //设置localStorage，保证页面刷新后vuex的值可以从里面读，避免刷新后状态丢失
        localStorage["NickName"] = user.NickName
        //登录成功后隐藏登录框
        store.commit('CloseRegister')
    } else {
        ElMessage.error(res.msg)
    }







}
const CloseRegister = () => {
    store.commit('CloseRegister')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(IsShowRegister),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(IsShowRegister) ? (IsShowRegister).value = $event : null)),
    title: "注册",
    width: "30%",
    "before-close": handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "昵称" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.NickName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.NickName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "用户名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.UserName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.UserName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "密码" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.Password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.Password) = $event)),
                type: "password",
                "show-password": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "验证码" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.ValidateCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.ValidateCode) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_el_image, {
                style: {"width":"200px","height":"100px"},
                src: vaildImages.value,
                onClick: ChangeImage
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: Submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: CloseRegister }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})